import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import no_summary from "../../../images/no_summary.svg";

/**
 * NoSummaryBox renders a message "No meeting summary" when
 * there are no available meeting summaries.
 *
 * This component showed when the summary list is empty.
 */
const NoSummaryBox = () => {
  return (
    <>
      <Column spacing="none" spacingInset="none">
        <Box width="316px" height="103px">
          <img src={no_summary} alt="comingSoon" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
        </Box>
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" height="16px"></Box>
        </Theme>
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" width="50px"></Box>
          </Theme>
          <Text fontFamily="amazonEmber" type="h200" alignment="start">
            No meeting summary
          </Text>
        </Row>
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" height="16px"></Box>
        </Theme>
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" width="50px"></Box>
          </Theme>
          <Box height="40px" width="234px">
            <Text fontFamily="amazonEmber" type="b200" alignment="start" color="secondary">
              Start summarizing your meeting
            </Text>
          </Box>
        </Row>
      </Column>
    </>
  );
};

export default NoSummaryBox;
